import cn from "classnames";
import "./CallOutWithTwoColumnsBlock.scss";
import {
  CallOutTextColumnBlock,
  GridPresetOneHalf,
  GridRow,
  OptimizelyEditProperty,
} from "/App.Components";
import { CallOutWithTwoColumnsBlockProps } from "/Models/Generated/CallOutWithTwoColumnsBlockProps";
import { NoradTheme } from "/Models/Generated/NoradTheme";
import { RowSpacing } from "/Components/Layout/GridRow/GridRow";

const CallOutWithTwoColumnsBlock = ({
  leftColumn,
  leftColumnPropertyName,
  rightColumn,
  rightColumnPropertyName,
  theme,
}: CallOutWithTwoColumnsBlockProps) => {
  return (
    <div
      className={cn("call-out-with-two-columns-block-norad", {
        "call-out-with-two-columns-block-norad--primary":
          theme === NoradTheme.Primary,
        "call-out-with-two-columns-block-norad--secondary":
          theme === NoradTheme.Secondary,
      })}
    >
      <GridRow rowSpacing={RowSpacing.xs}>
        {leftColumn && (
          <GridPresetOneHalf>
            <OptimizelyEditProperty
              propertyName={leftColumnPropertyName}
              useAvailableHeight
            >
              <div
                className={cn("call-out-with-two-columns-block-norad__column", {
                  "call-out-with-two-columns-block-norad__column--primary":
                    theme === NoradTheme.Primary,
                  "call-out-with-two-columns-block-norad__column--secondary":
                    theme === NoradTheme.Secondary,
                })}
              >
                <CallOutTextColumnBlock {...leftColumn} />
              </div>
            </OptimizelyEditProperty>
          </GridPresetOneHalf>
        )}
        {rightColumn && (
          <GridPresetOneHalf>
            <OptimizelyEditProperty
              propertyName={rightColumnPropertyName}
              useAvailableHeight
            >
              <div
                className={cn("call-out-with-two-columns-block-norad__column", {
                  "call-out-with-two-columns-block-norad__column--primary":
                    theme === NoradTheme.Primary,
                  "call-out-with-two-columns-block-norad__column--secondary":
                    theme === NoradTheme.Secondary,
                })}
              >
                <CallOutTextColumnBlock {...rightColumn} />
              </div>
            </OptimizelyEditProperty>
          </GridPresetOneHalf>
        )}
      </GridRow>
    </div>
  );
};

export default CallOutWithTwoColumnsBlock;
